import React from 'react';
import {COLORS, Image, SIZES, Typography} from '@fupa/fupa-uikit';
import {LinkOnComponent} from 'app/components/links/link';
import {ToTeamAlt} from 'app/styles/stream';
import {Emblem} from 'app/components/icons';
import styled from 'styled-components';
import {FlexContainer} from 'app/styles/content';
import formatTeamNameWithLevel from 'app/helpers/formatTeamNameWithLevel';

const LinkContainer = styled(LinkOnComponent)`
  flex: 1;
  overflow: hidden;
`;

const Team = styled(FlexContainer)`
  flex-direction: column;
  align-items: center;
  flex: 1;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
`;

const NameContainer = styled('div')`
  width: inherit;
`;

const TeamName = styled(Typography)`
  &&& {
    color: ${COLORS.black};
  }
  display: block;
  line-height: ${SIZES['24']};
  width: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
`;

interface MatchHeaderTeamProps {
  team: any;
  fallbackName: string;
}

export default function MatchHeaderTeam({team, fallbackName}: MatchHeaderTeamProps) {
  const emblem = team?.image ? (
    <Image entity='emblem' src={team.image} width={64} height={64} fit={true} />
  ) : (
    <ToTeamAlt>
      <Emblem className='' style={{color: COLORS.lightGrey, fontSize: 64}} />
    </ToTeamAlt>
  );

  const name = team?.name?.middle ? formatTeamNameWithLevel(team.name.middle, team.level) : fallbackName;

  const content = (
    <Team>
      {emblem}
      <NameContainer>
        <TeamName variant='subheading2' component='span'>
          {name}
        </TeamName>
      </NameContainer>
    </Team>
  );

  return team?.clubSlug && team.clubSlug !== 'dummy' ? (
    <LinkContainer to={`/team/${team.slug}`}>{content}</LinkContainer>
  ) : (
    content
  );
}
